import ObjectReference from './container'

export default ObjectReference